import { createContext, useCallback, useMemo, useState } from "react";

const CategoryDropdownContext = createContext()

export const CategoryDropdownProvider = ({ children }) => {
    const [dropdownName, setDropdownName] = useState("")

    const closeDropdown = useCallback(() => {
      setDropdownName("")
    }, [setDropdownName])
    
    const value = useMemo(() => {
      return {dropdownName, setDropdownName, closeDropdown}
    }, [dropdownName, setDropdownName, closeDropdown])

    return (
        <CategoryDropdownContext.Provider value={value}>
          {children}
        </CategoryDropdownContext.Provider>
      );
}

export default CategoryDropdownContext